import PropTypes from "prop-types";
export const HorizontalAlignment = Object.freeze({
    start: "start",
    end: "end",
    center: "center",
    spaceAround: "space-around",
    spaceBetween: "space-between",
});
export const VerticalAlignment = Object.freeze({
    top: "top",
    middle: "middle",
    bottom: "bottom",
});
export const HorizontalAlignPropTypes = PropTypes.oneOf(Object.values(HorizontalAlignment));
export const VerticalAlignPropTypes = PropTypes.oneOf(Object.values(VerticalAlignment));
//# sourceMappingURL=Alignment.js.map